import { AppGenericaProps } from './AppGenerica.types';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac';
const Enllac: any = EnllacComponent;
// @ts-ignore
import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './appgenerica.module.scss';

const AppGenerica = (props: Readonly<AppGenericaProps>) => {
    const { item } = props;

    if (!item) return null;

    const stylesAppGenerica = clsx({
        [styles.appGenerica]: true
    });

    return (
        <article className={stylesAppGenerica}>
            <Titol titol={item.titol} tag='h1' tipus='gran' estil='titolPagina' />
            {item.aplicacions && (
                <div className='gapAfter'>
                    <Imatge src={item.aplicacions?.[0]?.imatge} width={1328} height={747} alt={item.titol} priority={true} />
                </div>
            )}

            <p>{item.disponible}</p>

            {!__isEmpty(item.aplicacions) &&
                item.aplicacions?.map((app, index) => (
                    <div key={index} className={styles.markets}>
                        <>
                            <Enllac href={app.links[0].url} title={app.links[0].nom}>
                                <Imatge
                                    src={'https://statics.3cat.cat/recursos/ccma/apple-app-store.svg'}
                                    loading='lazy'
                                    width={88}
                                    height={26}
                                    alt={`${app.nom} ${app.links[0].nom}`}
                                    aria-hidden='true'
                                ></Imatge>
                            </Enllac>
                            <Enllac href={app.links[1].url} title={app.links[1].nom}>
                                <Imatge
                                    src={'https://statics.3cat.cat/recursos/ccma/google-play.svg'}
                                    loading='lazy'
                                    width={100}
                                    height={26}
                                    alt={`${app.nom} ${app.links[1].nom}`}
                                    aria-hidden='true'
                                ></Imatge>
                            </Enllac>
                        </>
                    </div>
                ))}

            <Text text={item.descarrega} tag='div' className='gapAfter' />
            <Text text={item.condicions} tag='div' className='gapAfter' />
            <Text text={item.ajuda} tag='div' className='gapAfter' />
        </article>
    );
};

export default AppGenerica;
